import React from 'react';
import { v4 } from 'uuid';
import DocumentItemsFormElement, { DocumentItemsFormElementSharedProps } from './DocumentItemsFormElement';
import {
  fromProposalItem, Item, DocumentAvailability, bindingLinePrice, suggestedResalePrice,
} from '../models/item';
import { ProposalItem } from '../models/proposal';
import usePricingSettings from '../hooks/usePricingSettings';
import { DEFAULT_PRICING_SETTINGS } from '../models/pricingSettings';

const ProposalItemsFormElement: React.FC<DocumentItemsFormElementSharedProps<ProposalItem>> = (props) => {
  // item 234 (reworked) — the proposal's binding line price is the GROUP price
  // (cost × group markup). The cost column carries the real dealer cost; the catalog's
  // retail becomes the MSRP/SRP suggestion (display only, never drives totals).
  const { pricing } = usePricingSettings();
  const defaults = pricing ?? DEFAULT_PRICING_SETTINGS;

  const makeItemFromCatalog = (newItem: Item, category: string): ProposalItem => ({
    brand: newItem.brand,
    category,
    costEach: newItem.costEach,
    description: newItem.description,
    id: v4(),
    includeInPo: false,
    itemId: newItem.id,
    quantity: 1,
    // item 422 — hardware: marked-up group price (never cost); services: the entered
    // group price. SRP: hardware cost × SRP markup; services group price × group markup.
    retailEach: bindingLinePrice(newItem),
    listPrice: suggestedResalePrice(newItem, defaults.groupMarkup, defaults.srpMarkup),
    isHardware: newItem.isHardware ?? false,
    sku: newItem.sku,
    taxable: false, // dart (2026-07-15, Chad) — per-line "Add tax" opt-in; default OFF (retired the catalog taxable flag)
    vendorId: newItem.vendorId,
  });

  return (
    <DocumentItemsFormElement<ProposalItem>
      categoryNames={props.categoryNames}
      items={props.items}
      setItems={props.setItems}
      categoryButtonHandler={props.categoryButtonHandler}
      activeCategory={props.activeCategory}
      categoryEditMode={props.categoryEditMode}
      editCategoryName={props.editCategoryName}
      setEditCategoryName={props.setEditCategoryName}
      onAddClose={props.onAddClose}
      isAddOpen={props.isAddOpen}
      showCost
      showRetail
      showMsrpPair
      showGrpPair
      defaultGrpMult={defaults.groupMarkup}
      defaultMsrpMult={defaults.srpMarkup}
      availableOn={DocumentAvailability.Proposal}
      makeItemFromCatalog={makeItemFromCatalog}
      toCatalogItem={fromProposalItem}
    />
  );
};

export default ProposalItemsFormElement;
